import { FilterOption } from "../models";

export function countCheckedFilters(filter: FilterOption): number {
  let count = 0;

  if (filter.type === "option" && filter.checked) {
    count += 1;
  }

  if (filter.options && filter.options.length > 0) {
    for (const option of filter.options) {
      count += countCheckedFilters(option);
    }
  }

  return count;
}
export function getCheckedFilters(filter: FilterOption): FilterOption[] {
  const checkedItems: FilterOption[] = [];

  if (filter.type === "option" && filter.checked) {
    checkedItems.push(filter);
  }

  if (filter.options && filter.options.length > 0) {
    for (const option of filter.options) {
      checkedItems.push(...getCheckedFilters(option));
    }
  }

  return checkedItems;
}

export function getAllCheckedFilters(filters: FilterOption[]): FilterOption[] {
  const result: FilterOption[] = [];

  filters.forEach((filter) => {
    result.push(...getCheckedFilters(filter));
  });

  return result;
}

export interface AppliedFilter {
  id: string;
  values: string[];
}

export interface AppliedFiltersByType {
  jurisprudencia?: AppliedFilter[];
  legislacao?: AppliedFilter[];
  doutrinas?: AppliedFilter[];
  peticoes?: AppliedFilter[];
  modelos?: AppliedFilter[];
  dicionario?: AppliedFilter[];
}

export function removeValueFromFilters(
  filters: AppliedFiltersByType,
  valueToRemove: string
): AppliedFilter[] {
  for (const [_, filterList] of Object.entries(filters)) {
    const safeList = Array.isArray(filterList) ? filterList : [];

    const updatedList = safeList
      .map((filter: AppliedFilter) => ({
        ...filter,
        values: (filter.values ?? []).filter(
          (value) => value.toLowerCase() !== valueToRemove.toLowerCase()
        ),
      }))
      .filter((filter: AppliedFilter) => filter.values.length > 0);

    const somethingRemoved = safeList.some((filter) =>
      filter.values.some(
        (value: string) => value.toLowerCase() === valueToRemove.toLowerCase()
      )
    );

    if (somethingRemoved) {
      return updatedList;
    }
  }

  return [];
}
